import styled, { css } from 'styled-components';

import { TTextAlignProperty } from '@_shared/types/property';
import { TColorNames } from '@_shared/styles';

import { TTypographySize } from './Typography.type';

interface IProps {
  textAlign?: TTextAlignProperty;
  italic?: boolean;
  underline?: boolean;
  color?: TColorNames;
  size: TTypographySize;
  noOfLine?: number;
}

const baseStyle = css<IProps>`
  color: ${({ theme, color }) => (color ? theme[color] : theme['font-primary'])};
  font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  text-align: ${({ textAlign }) => textAlign};

  word-break: keep-all;
  overflow-wrap: anywhere;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({ noOfLine }) => noOfLine || -1};
  -webkit-box-orient: vertical;
`;

export const Display = styled.h1<IProps>`
  ${baseStyle}

  font-style: normal;
  font-weight: 500;

  ${({ size }) => {
    switch (size) {
      case 'large':
        return css`
          font-size: 45px;
          line-height: 65px;
          letter-spacing: -0.25px;
        `;
      case 'medium':
        return css`
          font-size: 36px;
          line-height: 52px;
        `;
      case 'small':
        return css`
          font-size: 32px;
          line-height: 52px;
        `;
    }
  }};
`;

export const Headline = styled.h2<IProps>`
  ${baseStyle}

  font-weight: 600;

  ${({ size }) => {
    switch (size) {
      case 'large':
        return css`
          font-size: 24px;
          line-height: 40px;
        `;
      case 'medium':
        return css`
          font-size: 22px;
          line-height: 36px;
        `;
      case 'small':
        return css`
          font-size: 20px;
          line-height: 32px;
        `;
    }
  }};
`;

export const Title = styled.h3<IProps>`
  ${baseStyle}

  font-weight: 600;

  ${({ size }) => {
    switch (size) {
      case 'large':
        return css`
          font-size: 16px;
          line-height: 28px;
        `;
      case 'medium':
        return css`
          font-size: 14px;
          line-height: 24px;
        `;
      case 'small':
        return css`
          font-size: 12px;
          line-height: 20px;
        `;
      case 'mini':
        return css`
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
        `;
    }
  }};
`;

export const Label = styled.span<IProps>`
  ${baseStyle}

  font-weight: 400;

  ${({ size }) => {
    switch (size) {
      case 'large':
        return css`
          font-size: 12px;
          line-height: 20px;
        `;
      case 'medium':
        return css`
          font-size: 11px;
          line-height: 16px;
        `;
    }
  }};
`;

export const Body = styled.p<IProps>`
  ${baseStyle}

  font-weight: 400;

  ${({ size }) => {
    switch (size) {
      case 'large':
        return css`
          font-size: 14px;
          line-height: 24px;
        `;
      case 'medium':
        return css`
          font-size: 12px;
          line-height: 20px;
        `;
    }
  }};
`;
